<template>
  <div class="notice">
    <!-- 通知中心 -->
    <div class="mt20"
         v-loading="loading">
      <el-collapse v-model="activeNames"
                   accordion
                   @change="handleChange">
        <el-collapse-item v-for="(item,index) in noticeData.list"
                          :key="index"
                          :title="`${item.created_at}   ${item.notify_title}`"
                          :name="index">
          <div class="space"></div>
          <div class="notice-content">
            <p><span>{{item.content}}</span>
              <!-- <span class="part">|</span> -->
              <!-- <span>{{item.headline}}</span> -->
              <!-- <span class="ml20">总预约提醒人数{{item.order_num}}</span> -->
              <!-- <span class="ml10">通知成功{{item.order_num-3}}人/失败{{30}}</span> -->
            </p>

            <!-- <div class="mt20">
                <span class="vt">失败原因：</span>
                <ul class="iblock">
                    <li v-for="(item,index) in item.errorMessage" :key="index">
                        <span>{{item.message}}</span>
                        <span class="ml20">{{item.num}}人</span>
                    </li>
                </ul>
            </div> -->
          </div>
        </el-collapse-item>
      </el-collapse>

      <div class="tc mt20">
        <el-pagination background
                       @current-change="handleCurrentChange"
                       :current-page="search.page"
                       :page-size="search.size"
                       layout="total, prev, pager, next"
                       :total="Number(noticeData.count)"></el-pagination>
      </div>

    </div>
  </div>
</template>

<script>

import { _notifyList } from '@/api/notify';

export default {
  created () {
    this.initNotifyList();
  },
  data () {
    return {
      activeNames: [""],
      search: {
        page: 1,
        size: 10
      },
      loading: false,
      noticeData: [
        {
          date: "6月20日",
          subtitle: "人脸识别技术公开课虹软专场第1讲",
          headline: " 《人脸识别技术的商业落地及挑战》",
          order_num: "33",
          errorMessage: [
            {
              num: 1,
              message: "C端用户已关闭该板块的模版消息"
            },
            {
              num: 2,
              message: "用户未关注公众号"
            }
          ]
        },
        {
          date: "6月18日",
          subtitle: "人脸识别技术公开课虹软专场第1讲",
          headline: " 《人脸识别技术的商业落地及挑战》",
          order_num: "33",
          errorMessage: [
            {
              num: 1,
              message: "C端用户已关闭该板块的模版消息"
            },
            {
              num: 2,
              message: "用户未关注公众号"
            }
          ]
        },
        {
          date: "6月11日",
          subtitle: "人脸识别技术公开课虹软专场第1讲",
          headline: " 《人脸识别技术的商业落地及挑战》",
          order_num: "33",
          errorMessage: [
            {
              num: 1,
              message: "C端用户已关闭该板块的模版消息"
            },
            {
              num: 2,
              message: "用户未关注公众号"
            }
          ]
        },
        {
          date: "6月06日",
          subtitle: "人脸识别技术公开课虹软专场第1讲",
          headline: " 《人脸识别技术的商业落地及挑战》",
          order_num: "33",
          errorMessage: [
            {
              num: 1,
              message: "C端用户已关闭该板块的模版消息"
            },
            {
              num: 2,
              message: "用户未关注公众号"
            }
          ]
        },
        {
          date: "6月03日",
          subtitle: "人脸识别技术公开课虹软专场第1讲",
          headline: " 《人脸识别技术的商业落地及挑战》",
          order_num: "33",
          errorMessage: [
            {
              num: 1,
              message: "C端用户已关闭该板块的模版消息"
            },
            {
              num: 2,
              message: "用户未关注公众号"
            }
          ]
        },
      ]
    };
  },
  methods: {
    handleChange (val) {
      // console.log(val);
    },
    //请求接口数据
    initNotifyList () {
      this.loading = true;
      _notifyList({
        params: {
          page: this.search.page,
          size: this.search.size,
          notify_mode: 1
        }
      }).then(res => {
        this.loading = false;
        if (res.resultCode == 1) {
          // console.log(res);
          this.noticeData = res.result;
          //发送异步事件更新通知中心的数量
          this.$store.dispatch('clearMessageTotAsy');
        } else {
          tiis.$message.error(res.errorMsg);
        }
      })
    },
    //翻页
    handleCurrentChange (val) {
      this.search.page = val
      this.initNotifyList()
    },
  }
};
</script>


<style lang="less" scoped>
.notice {
  .notice-content {
    width: 100%;
    overflow: hidden;
    padding: 20px 0 20px 40px;
    background: #efefef;
    .part {
      display: inline-block;
      padding: 0 5px;
    }
  }
}
</style>

<style lang="less">
.notice {
  .el-collapse-item__header {
    padding-left: 20px;
  }
  .el-collapse-item__content {
    padding-bottom: 0;
  }
}
</style>